'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ua = global.navigator ? global.navigator.userAgent || '' : '';
var IS_EDGE = ua.indexOf('Edge/') !== -1;
var IS_MS_BROWSER = IS_EDGE || ua.indexOf('Trident') !== -1;
var IS_IE = IS_MS_BROWSER && !IS_EDGE;
var IS_FF = ua.toLowerCase().indexOf('firefox') > -1;

exports.IS_EDGE = IS_EDGE;
exports.IS_IE = IS_IE;
exports.IS_MS_BROWSER = IS_MS_BROWSER;
exports.IS_FF = IS_FF;